var $ = require('jquery');
var Util = {};

/**
 *
 * @param val
 * @param num
 * @param long 为false时 舍去无意义的0
 * @returns {Number}
 */
Util.toFixed = function (val, num, long) {
    var str,
        _num = $.isNumeric(num) ? (num > 0 ? num : 0) : 1,
        parse = _num == 0 ? parseInt : parseFloat,
        value = parse(val);
    if (!isNaN(value)) {
        if (_num != 0 && !long) {
            str = value.toFixed(_num) + '';
            value = parseFloat(str.replace(/0+$|\.0+$/, ''));
        } else {
            value = value.toFixed(_num);
        }
    }
    return value;
};

/**
 * @description 查询search 参数的值
  * @param name
 * @returns {*}
 */
// 删除  用 trf.url('?name') 代替
/*Util.getQueryString = function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
};*/

Util.openWebPage = function (options) {
    function formOpen(opts) {
        var _form = $('<form style="display:none"></form>');
        opts = opts || {};
        _form.attr({
            'method': opts.type || 'get',
            'action': opts.url,
            'target': opts.target || '_blank',
            'style': 'display:none'
        });
        opts.data && $.each(opts.data, function (key, val) {
            _form.append('<input type="hidden" name="' + key + '" value="' + val + '">');
        });
        $("body").append(_form);
        //触发提交事件
        _form.trigger("submit");
        //表单删除
        _form.remove();
    }
    function winOpen(opts) {
        opts = opts || {};
        var url = opts.url+'';
        if(opts.data){
            url += (url.indexOf('?') === -1 ? '?' : '&') + $.param(opts.data);
        }
        window.open(url,opts.target || '_blank');
    }

    options.type == 'post' ? formOpen(options) :winOpen(options);
};
Util.closeWebPage = function (){
    window.open('','_self','');
    window.close();
};
Util.batchTemplate = function (tpl,name) {
    var obj = {};
    var selector = 'script[type="text/html"]';
    var $tpl = $(tpl);
    name = name || 'tplName';

    function add() {
        var $this = $(this);
        var tplName = $this.data(name);
        if(tplName){
            obj[tplName] = $this.html();
        }
    }
    $tpl.filter(selector).each(add);
    $tpl.find(selector).each(add);

    return obj;
};

/**
 * Trims the . and .. from an array of path segments.
 * It will keep a leading path segment if a .. will become
 * the first path segment, to help with module name lookups,
 * which act like paths, but can be remapped. But the end result,
 * all paths that use this function should look normalized.
 * NOTE: this method MODIFIES the input array.
 * @param {Array} ary the array of path segments.
 */
function trimDots(ary) {
    var i, part;
    for (i = 0; i < ary.length; i++) {
        part = ary[i];
        if (part === '.') {
            ary.splice(i, 1);
            i -= 1;
        } else if (part === '..') {
            // If at the start, or previous value is still ..,
            // keep them so that when converted to a path it may
            // still work when converted to a path, even though
            // as an ID it is less than ideal. In larger point
            // releases, may be better to just kick out an error.
            if (i === 0 || (i === 1 && ary[2] === '..') || ary[i - 1] === '..') {
                continue;
            } else if (i > 0) {
                ary.splice(i - 1, 2);
                i -= 2;
            }
        }
    }
}
Util.normalizeUrlPath = function (url) {
    var list = (url?url+'':'').split('/');
    trimDots(list);
    return  list.join('/');
};

Util.createTimer = function (fn,time) {
    var timerId;
    var clearFlag;
    var timer = {
        start:function (immediately) {
            clearFlag = false;
            immediately &&  fn(timer);
            timing();
        },
        stop:function () {
            clearFlag = true;
            if(typeof timerId !== 'undefined'){
                clearTimeout(timerId);
            }
        }
    };
    time = time || 60000;
    function timing() {
        if(typeof timerId !== 'undefined'){
            clearTimeout(timerId);
        }
        timerId = setTimeout(function () {
            var ret = fn(timer);
            if(ret && $.type(ret.then)==='function'){
                Promise.resolve(ret).then(function () {
                    clearFlag || timing();
                });
            }else{
                clearFlag || timing();
            }
        },time);
    }
    return timer;
};

/**
 * 判断是否为空
 * @param value
 * @returns {string}
 */
Util.isNull=function(value) {
    return value === null || value === '' || value===undefined ? '---' : value;
}

module.exports = Util;



//////////////////
// WEBPACK FOOTER
// ./src/core/util.js
// module id = 85
// module chunks = 0